import { Form, InputNumber } from 'antd'
import { FC } from 'react'
import { requiredInputNumberRules } from '../../../../../constants/forms/validation/rules'

interface LengthProps {
    onChange: (value: number | null) => void
}

const Length: FC<LengthProps> = ({ onChange }) => {
    return (
        <Form.Item name={'length'} label={'Длина'} rules={requiredInputNumberRules}>
            <InputNumber onChange={onChange} />
        </Form.Item>
    )
}

export default Length
